const trackLogin = () => {
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'event',
      'eventCategory': 'Sales Portal',
      'eventAction': 'Partner Login',
      'eventLabel': 'Login',
      'eventNonInteraction': false
    });
  }
};

const trackOwnerLogin = () => {
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'event',
      'eventCategory': 'Sales Portal',
      'eventAction': 'Owner Login',
      'eventLabel': 'Login',
      'eventNonInteraction': false
    });
  }
};

const trackForgotPassword = () => {
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'event',
      'eventCategory': 'Sales Portal',
      'eventAction': 'Partner Login',
      'eventLabel': 'Forgot Password',
      'eventNonInteraction': false
    });
  }
};

const trackRegister = () => {
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'event',
      'eventCategory': 'Sales Portal',
      'eventAction': 'Partner Login',
      'eventLabel': 'No account yet',
      'eventNonInteraction': false
    });
  }
};

const forgotPassword = document.querySelectorAll('.password-forgot-link');
forgotPassword.forEach((el) => {
  el.addEventListener('click', trackForgotPassword);
});

const register = document.querySelectorAll('.password-register');
register.forEach((el) => {
  el.addEventListener('click', trackRegister);
});

// PARTNER LOGIN
const partnerLoginForms = document.querySelectorAll('form[data-name="partner-login"]');
partnerLoginForms.forEach((form) => {
  const userInput = form.querySelector('#login-partner-id');
  const passwordInput = form.querySelector('#login-partner-password');
  const loaderLayer = form.querySelector('.loader-layer')
  const errorEl = form.querySelector('.field-error');

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    errorEl.innerHTML = '';
    loaderLayer.classList.add('-active');

    trackLogin();

    const partnersBaseUrl = form.dataset.redirectUrl;
    let formAction = form.getAttribute('action');

    // remove GA tracking from login url after failed login attempt
    if (formAction.includes('?')) {
      formAction = formAction.split('?')[0];
    }

    window.axios.post(formAction, {
      partnerId: userInput.value,
      password: passwordInput.value
    }, {
      withCredentials: true
    })
    .then(function (response) {
      loaderLayer.classList.remove('-active');
      console.info('Successful login request', response);

      if (form.dataset.referer) {
        window.location.href = form.dataset.referer;
      } else if (response.data && response.data.locale) {
        window.location.href = partnersBaseUrl + response.data.locale;
      } else {
        console.error('No locale in login response.');
        errorEl.innerHTML = 'No locale in login response.';
      }
    })
    .catch(function (error) {
      loaderLayer.classList.remove('-active');
      errorEl.innerHTML = error;
    });

  });

});

// OWNER LOGIN
const ownerLoginForms = document.querySelectorAll('form[data-name="owner-login"]');
ownerLoginForms.forEach((form) => {
  const userInput = form.querySelector('#login-owner-supplier-id');
  const passwordInput = form.querySelector('#login-owner-password');
  const loaderLayer = form.querySelector('.loader-layer');
  const errorEl = form.querySelector('.field-error');

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    errorEl.innerHTML = '';
    loaderLayer.classList.add('-active');

    trackOwnerLogin();

    const ownersBaseUrl = form.dataset.redirectUrl;
    const formAction = form.getAttribute('action');

    const params = new URLSearchParams();
    params.append('supplierId', userInput.value);
    params.append('password', passwordInput.value);

    window.axios.post(formAction, params, {
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      withCredentials: true
    })
    .then(function (response) {
      loaderLayer.classList.remove('-active');
      console.info('Successful login request', response);

      if (form.dataset.referer) {
        window.location.href = form.dataset.referer;
      } else {
        window.location.href = ownersBaseUrl;
      }
    })
    .catch(function (error) {
      loaderLayer.classList.remove('-active');
      errorEl.innerHTML = error;
    });

  });

});

// iframe Login
window.addEventListener('message', (event) => {
  if (event.data && event.data.message == 'login') {
    window.location.href = event.data.target;
  }
}, false);
